import APP_ACTIONS from '../constants/app-actions';

const backgroundDisabled = {
    setBackgroundDisabled: (payload) => ({
        type: APP_ACTIONS.SET_BACKGROUND_DISABLED,
        payload,
    }),
};

export default backgroundDisabled;



/** WEBPACK FOOTER **
 ** ./src/actions/background-disabled.js
 **/